export default "__VITE_ASSET__CCByzpJz__"